// Scan project root để liệt kê các file/folder Avatar đã tạo. Output là blueprint
// cho uninstall: cái gì sẽ xóa + cái gì sẽ edit (gitignore, gitmodules).
import { existsSync } from "node:fs";
import { join } from "node:path";

export interface AvatarProjectArtifacts {
  hasAnyArtifact: boolean;
  claudeDir: string | null; // .claude/
  claudeMd: string | null; // CLAUDE.md
  postMergeHook: string | null; // .git/hooks/post-merge
  prePushHook: string | null; // .git/modules/src/hooks/pre-push
  gitignorePath: string | null; // .gitignore (nếu có Avatar block)
  gitmodulesPath: string | null; // .gitmodules (nếu có submodule .claude/pack)
  notesDir: string | null; // notes/ (workspace mode)
  scriptsDir: string | null; // scripts/ (workspace mode)
}

function existsOrNull(path: string): string | null {
  return existsSync(path) ? path : null;
}

export function detectAvatarProjectArtifacts(projectRoot: string): AvatarProjectArtifacts {
  const claudeDir = existsOrNull(join(projectRoot, ".claude"));
  const claudeMd = existsOrNull(join(projectRoot, "CLAUDE.md"));
  const postMergeHook = existsOrNull(join(projectRoot, ".git", "hooks", "post-merge"));
  const prePushHook = existsOrNull(
    join(projectRoot, ".git", "modules", "src", "hooks", "pre-push"),
  );
  const gitignorePath = existsOrNull(join(projectRoot, ".gitignore"));
  const gitmodulesPath = existsOrNull(join(projectRoot, ".gitmodules"));
  const notesDir = existsOrNull(join(projectRoot, "notes"));
  const scriptsDir = existsOrNull(join(projectRoot, "scripts"));

  const hasAnyArtifact = !!(claudeDir || claudeMd || postMergeHook || prePushHook);

  return {
    hasAnyArtifact,
    claudeDir,
    claudeMd,
    postMergeHook,
    prePushHook,
    gitignorePath,
    gitmodulesPath,
    notesDir,
    scriptsDir,
  };
}
